module.exports = __webpack_public_path__ + "img/code-show-results.0804e1ca.png";